import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Unit_instance104q5opgivhr8 as Unit_instance,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  LazyThreadSafetyMode_PUBLICATION_getInstance2x9bac6dffafm as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  Result3t1vadv16kmzk as Result,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$,
  _Result___get_isSuccess__impl__sndoy82z6txcyihce8z as _Result___get_isSuccess__impl__sndoy8,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  emptyList1g2z5xcrvp2zy as emptyList,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  serializer1i4e9ym37oxmo as serializer,
  KSerializerzf77vz1967fq as KSerializer,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  SimpleListEndpointCacheStrategy1m0xsspwu4sws as SimpleListEndpointCacheStrategy,
  IListLocalSource39ga4nlfbxuv1 as IListLocalSource,
  IEnvironmentProvider2spq4fpbokmem as IEnvironmentProvider,
  SimpleListCacheLocalSource9ig3nhg8ocnr as SimpleListCacheLocalSource,
} from './Shared7Punches-common-base.mjs';
import {
  INetworkDataProvider2v0ql8qlip169 as INetworkDataProvider,
  getRaw1iqjzl4utwpzp as getRaw,
  Clientssjxb7gh2u6y as Client,
  Companion_instance2qqqduu61k50l as Companion_instance_0,
  ProjectInfo1qp9h4onrx4i2 as ProjectInfo,
} from './Shared7Punches-infrastructure-network.mjs';
import { Jsonsmkyu9xjl7fv as Json } from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import {
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { ILoggingProvider3qgs59b4tde8f as ILoggingProvider } from './Shared7Punches-infrastructure-logging.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiSandbox, 'ApiSandbox', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiSandboxListResponse, 'ApiSandboxListResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForLambda(SandboxRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(SandboxRepository$cacheStrategy$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForInterface(ISandboxAccessor, 'ISandboxAccessor');
initMetadataForClass(SandboxRepository, 'SandboxRepository', VOID, VOID, [ISandboxAccessor]);
initMetadataForInterface(ISandboxRemoteSource, 'ISandboxRemoteSource', VOID, VOID, VOID, [0]);
initMetadataForObject(SandboxNetworkDataProvider, 'SandboxNetworkDataProvider', VOID, VOID, [INetworkDataProvider], [0]);
initMetadataForCoroutine($listCOROUTINE$0, CoroutineImpl);
initMetadataForClass(SandboxRemoteSource, 'SandboxRemoteSource', VOID, VOID, [ISandboxRemoteSource], [0]);
initMetadataForClass(Sandbox, 'Sandbox');
//endregion
function Companion() {
}
var Companion_instance_1;
function Companion_getInstance_0() {
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.sandbox.data.ApiSandbox', this, 1);
  tmp0_serialDesc.wy('name', false);
  this.r9t_1 = tmp0_serialDesc;
}
protoOf($serializer).s9t = function (encoder, value) {
  var tmp0_desc = this.r9t_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.zs(tmp0_desc, 0, value.t9t_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.s9t(encoder, value instanceof ApiSandbox ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.r9t_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiSandbox_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).xn = function () {
  return this.r9t_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiSandbox_init_$Init$(seen0, name, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance().r9t_1);
  }
  $this.t9t_1 = name;
  return $this;
}
function ApiSandbox_init_$Create$(seen0, name, serializationConstructorMarker) {
  return ApiSandbox_init_$Init$(seen0, name, serializationConstructorMarker, objectCreate(protoOf(ApiSandbox)));
}
function ApiSandbox(name) {
  this.t9t_1 = name;
}
protoOf(ApiSandbox).toString = function () {
  return 'ApiSandbox(name=' + this.t9t_1 + ')';
};
protoOf(ApiSandbox).hashCode = function () {
  return getStringHashCode(this.t9t_1);
};
protoOf(ApiSandbox).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiSandbox))
    return false;
  var tmp0_other_with_cast = other instanceof ApiSandbox ? other : THROW_CCE();
  if (!(this.t9t_1 === tmp0_other_with_cast.t9t_1))
    return false;
  return true;
};
function ApiSandboxListResponse$Companion$$childSerializers$_anonymous__v6x7sy() {
  return new ArrayListSerializer(StringSerializer_getInstance());
}
function Companion_0() {
  Companion_instance_2 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.u9t_1 = [lazy(tmp_0, ApiSandboxListResponse$Companion$$childSerializers$_anonymous__v6x7sy)];
}
var Companion_instance_2;
function Companion_getInstance_1() {
  if (Companion_instance_2 == null)
    new Companion_0();
  return Companion_instance_2;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.sandbox.data.ApiSandboxListResponse', this, 1);
  tmp0_serialDesc.wy('items', false);
  this.v9t_1 = tmp0_serialDesc;
}
protoOf($serializer_0).w9t = function (encoder, value) {
  var tmp0_desc = this.v9t_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_1().u9t_1;
  tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0].t(), value.x9t_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_0).yn = function (encoder, value) {
  return this.w9t(encoder, value instanceof ApiSandboxListResponse ? value : THROW_CCE());
};
protoOf($serializer_0).zn = function (decoder) {
  var tmp0_desc = this.v9t_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  var tmp6_cached = Companion_getInstance_1().u9t_1;
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, tmp6_cached[0].t(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, tmp6_cached[0].t(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiSandboxListResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_0).xn = function () {
  return this.v9t_1;
};
protoOf($serializer_0).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_1().u9t_1[0].t()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function ApiSandboxListResponse_init_$Init$(seen0, items, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_0().v9t_1);
  }
  $this.x9t_1 = items;
  return $this;
}
function ApiSandboxListResponse_init_$Create$(seen0, items, serializationConstructorMarker) {
  return ApiSandboxListResponse_init_$Init$(seen0, items, serializationConstructorMarker, objectCreate(protoOf(ApiSandboxListResponse)));
}
function ApiSandboxListResponse(items) {
  Companion_getInstance_1();
  this.x9t_1 = items;
}
protoOf(ApiSandboxListResponse).toString = function () {
  return 'ApiSandboxListResponse(items=' + toString(this.x9t_1) + ')';
};
protoOf(ApiSandboxListResponse).hashCode = function () {
  return hashCode(this.x9t_1);
};
protoOf(ApiSandboxListResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiSandboxListResponse))
    return false;
  var tmp0_other_with_cast = other instanceof ApiSandboxListResponse ? other : THROW_CCE();
  if (!equals(this.x9t_1, tmp0_other_with_cast.x9t_1))
    return false;
  return true;
};
function toDomain(_this__u8e3s4) {
  return new Sandbox(_this__u8e3s4.t9t_1);
}
function SandboxRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.g9u_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SandboxRepository$cacheStrategy$slambda).i9u = function (it, $completion) {
  var tmp = this.j9u(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(SandboxRepository$cacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.i9u((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(SandboxRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.g9u_1.l9u_1.m2u(this.h9u_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(SandboxRepository$cacheStrategy$slambda).j9u = function (it, completion) {
  var i = new SandboxRepository$cacheStrategy$slambda(this.g9u_1, completion);
  i.h9u_1 = it;
  return i;
};
function SandboxRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new SandboxRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.i9u(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function SandboxRepository$cacheStrategy$slambda_1(this$0, resultContinuation) {
  this.v9u_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SandboxRepository$cacheStrategy$slambda_1).w9u = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(SandboxRepository$cacheStrategy$slambda_1).ma = function ($completion) {
  return this.w9u($completion);
};
protoOf(SandboxRepository$cacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.v9u_1.k9u_1.x9u(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(SandboxRepository$cacheStrategy$slambda_1).m32 = function (completion) {
  return new SandboxRepository$cacheStrategy$slambda_1(this.v9u_1, completion);
};
function SandboxRepository$cacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new SandboxRepository$cacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function ($completion) {
    return i.w9u($completion);
  };
  l.$arity = 0;
  return l;
}
function SandboxRepository$cacheStrategy$lambda(it) {
  return toDomain(it);
}
function SandboxRepository$cacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.y9u_1;
}
function SandboxRepository(remoteSource, localSource) {
  this.k9u_1 = remoteSource;
  this.l9u_1 = localSource;
  var tmp = this;
  var tmp_0 = this.l9u_1.n18();
  var tmp_1 = SandboxRepository$cacheStrategy$slambda_0(this, null);
  var tmp_2 = SandboxRepository$cacheStrategy$slambda_2(this, null);
  var tmp_3 = SandboxRepository$cacheStrategy$lambda;
  tmp.m9u_1 = new SimpleListEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, tmp_3, SandboxRepository$cacheStrategy$lambda_0);
}
function ISandboxRemoteSource() {
}
function SandboxNetworkDataProvider() {
}
protoOf(SandboxNetworkDataProvider).f6k = function () {
  return 'https://app.7shifts.dev';
};
protoOf(SandboxNetworkDataProvider).y6l = function () {
  return 'wss://phx-ws.7shifts.dev/auth_user_socket/websocket';
};
var SandboxNetworkDataProvider_instance;
function SandboxNetworkDataProvider_getInstance() {
  return SandboxNetworkDataProvider_instance;
}
function SandboxRemoteSource$json$lambda($this$Json) {
  $this$Json.k60_1 = true;
  return Unit_instance;
}
function $listCOROUTINE$0(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.h9v_1 = _this__u8e3s4;
}
protoOf($listCOROUTINE$0).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = getRaw(this.h9v_1.i9v_1, '_list.json', this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var this_1 = this.h9v_1.j9v_1;
            var this_2 = this_1.zr();
            var this_3 = serializer(this_2, createKType(getKClass(ApiSandboxListResponse), arrayOf([]), false));
            var this_4 = this_1.bp(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), it).x9t_1;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
            var _iterator__ex2g4s = this_4.j();
            while (_iterator__ex2g4s.k()) {
              var item = _iterator__ex2g4s.l();
              destination.e(new ApiSandbox(item));
            }
            tmp_0 = _Result___init__impl__xyqfz8(destination);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function SandboxRemoteSource(api) {
  this.i9v_1 = api;
  var tmp = this;
  tmp.j9v_1 = Json(VOID, SandboxRemoteSource$json$lambda);
}
protoOf(SandboxRemoteSource).x9u = function ($completion) {
  var tmp = new $listCOROUTINE$0(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function get_sandboxModule() {
  _init_properties_SandboxModule_kt__7wdsm9();
  return sandboxModule;
}
var sandboxModule;
function sandboxModule$lambda($this$module) {
  _init_properties_SandboxModule_kt__7wdsm9();
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp1 = new TypeQualifier(getKClass(SandboxRemoteSource));
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = sandboxModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(Client), tmp1, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = sandboxModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(ISandboxRemoteSource), null, definition, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp8 = new TypeQualifier(getKClass(Sandbox));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = sandboxModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(IListLocalSource), tmp8, definition_0, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = sandboxModule$lambda$lambda_2;
  var scopeQualifier_2 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Singleton_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(SandboxRepository), null, definition_1, kind_2, secondaryTypes_2);
  var factory_2 = new SingleInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_2);
  }
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_2 = sandboxModule$lambda$lambda_3;
  var scopeQualifier_3 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Singleton_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(ISandboxAccessor), null, definition_2, kind_3, secondaryTypes_3);
  var factory_3 = new SingleInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_3);
  }
  new KoinDefinition($this$module, factory_3);
  return Unit_instance;
}
function sandboxModule$lambda$lambda($this$factory, it) {
  _init_properties_SandboxModule_kt__7wdsm9();
  var tmp = Companion_instance_0;
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(ILoggingProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$factory.q1d(getKClass(ProjectInfo), null, null);
  var tmp_2 = SandboxNetworkDataProvider_instance;
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$factory.q1d(getKClass(IEnvironmentProvider), null, null);
  return tmp.e6l(tmp_0, tmp_1, tmp_2, tmp$ret$2);
}
function sandboxModule$lambda$lambda_0($this$single, it) {
  _init_properties_SandboxModule_kt__7wdsm9();
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(SandboxRemoteSource));
  var tmp$ret$1 = $this$single.q1d(getKClass(Client), qualifier, null);
  return new SandboxRemoteSource(tmp$ret$1);
}
function sandboxModule$lambda$lambda_1($this$single, it) {
  _init_properties_SandboxModule_kt__7wdsm9();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('SANDBOX_CACHE_KEY', tmp$ret$0);
}
function sandboxModule$lambda$lambda_2($this$single, it) {
  _init_properties_SandboxModule_kt__7wdsm9();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(ISandboxRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(Sandbox));
  var tmp$ret$2 = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  return new SandboxRepository(tmp, tmp$ret$2);
}
function sandboxModule$lambda$lambda_3($this$single, it) {
  _init_properties_SandboxModule_kt__7wdsm9();
  // Inline function 'org.koin.core.scope.Scope.get' call
  return $this$single.q1d(getKClass(SandboxRepository), null, null);
}
var properties_initialized_SandboxModule_kt_tsxpst;
function _init_properties_SandboxModule_kt__7wdsm9() {
  if (!properties_initialized_SandboxModule_kt_tsxpst) {
    properties_initialized_SandboxModule_kt_tsxpst = true;
    sandboxModule = module_0(VOID, sandboxModule$lambda);
  }
}
function ISandboxAccessor() {
}
function Sandbox(name) {
  this.y9u_1 = name;
}
protoOf(Sandbox).toString = function () {
  return 'Sandbox(name=' + this.y9u_1 + ')';
};
protoOf(Sandbox).hashCode = function () {
  return getStringHashCode(this.y9u_1);
};
protoOf(Sandbox).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Sandbox))
    return false;
  var tmp0_other_with_cast = other instanceof Sandbox ? other : THROW_CCE();
  if (!(this.y9u_1 === tmp0_other_with_cast.y9u_1))
    return false;
  return true;
};
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf($serializer_0).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_1 = new Companion();
SandboxNetworkDataProvider_instance = new SandboxNetworkDataProvider();
//endregion
//region block: exports
export {
  get_sandboxModule as get_sandboxModulerp1j55r8pufg,
  ISandboxAccessor as ISandboxAccessor1z1bzul8o2ia1,
};
//endregion

